export function breedPageSurface<TBreed extends { id: string }>(input: {
    breeds: readonly TBreed[] | undefined;
    breedId: string;
    isLoading: boolean;
}) {
    if (input.isLoading) return { state: "loading" } as const;
    const breed = input.breeds?.find((item) => item.id === input.breedId);
    if (!breed) return { state: "missing" } as const;
    return { state: "ready", breed } as const;
}
